import { isAxiosError } from 'axios';
import { IntakeTransferRequest, IntakeTransferStatus } from '../../types/intakeTransfer';

export const SUPER_ADMIN_ROLE = 'Super Admin';

/** Application statuses that can no longer be transferred (mirrors the
 * backend's TERMINAL_STATUSES). */
export const NON_TRANSFERABLE_STATUSES = [
  'DEPARTED',
  'ARRIVED',
  'WITHDRAWN',
  'REJECTED',
  'VISA_REJECTED',
];

export const transferErrorMessage = (err: unknown, fallback = 'Something went wrong.') =>
  isAxiosError(err) ? (err.response?.data?.message ?? fallback) : fallback;

export const TRANSFER_STATUS_CHIP: Record<
  IntakeTransferStatus,
  { label: string; color: 'warning' | 'success' | 'error' }
> = {
  PENDING: { label: 'Pending approval', color: 'warning' },
  APPROVED: { label: 'Approved', color: 'success' },
  REJECTED: { label: 'Rejected', color: 'error' },
};

export const personName = (p: { firstName: string; lastName: string } | null) =>
  p ? `${p.firstName} ${p.lastName}` : '—';

/** "Intake A → Intake B" and, when the batch changes, "Batch X → Batch Y". */
export const describeTransfer = (r: IntakeTransferRequest) => {
  const intake = `${r.fromIntake?.name ?? 'No intake'} → ${r.toIntake.name}`;
  const batchChanges = r.fromBatchNumber !== r.toBatchNumber;
  const batch = batchChanges
    ? `${r.fromBatchNumber ?? 'No batch'} → ${r.toBatchNumber ?? 'No batch'}`
    : null;
  return { intake, batch };
};
